import { Util } from "@xt/xtbase";
import { navPublicAssetUrl } from "../utils/navPublicAssetUrl";
import styles from "./index.module.less";

const { getUrl } = Util;

/** 对齐 spikex-ai-web Logo：mark + SpikeX 字标 */
export default function GlobalHeaderLogo() {
  return (
    <a href={getUrl("/")} className={styles.logo} aria-label="SpikeX home">
      <img
        src={navPublicAssetUrl("brand/logo-mark.png")}
        alt=""
        width={30}
        height={30}
        className={styles.logoMark}
        draggable={false}
      />
      <span className={styles.logoWordmark}>
        Spike<span className={styles.logoAccent}>X</span>
      </span>
    </a>
  );
}
